/**
 * Render Vue.js
 *
 * Examples:
 * ```
 * <div class="mod-example" data-js-vue="message: Hello Vue.js!">
 *     {{ message }}
 * </div>
 *
 * <div data-js-vue data-app="app-example">
 *     Modul wird geladen...
 * </div>
 * ```
 */
S.vue = {
    /**
     * @var {Vue} Vue instance
     */
    vue: null,

    /**
     * @var {Vue[]} Vue cache
     * @private
     */
    cache: [],

    init()
    {
        const
            app = this.$module.attr('data-app'),
            el = this.$module.get(0),
            data = this.config;

        // we don't care about this module once Vue is initialized
        this.$module.removeAttr('data-app');
        this.$module.removeAttr('data-js-vue');

        if (app)
        {
            if (typeof S.vue.cache[app] !== 'function')
            {
                console.warn(`Could not initialize Vue app "${app}"`);

                return;
            }

            // render the precompiled app
            this.vue = S.vue.cache[app](el, data);
        }

        else
        {
            // initialize Vue
            this.vue = new Vue({
                el,
                data()
                {
                    return data;
                },
            });
        }
    },
};
